<template>
  <div id="error-container">
    <section class="relative mx-auto">
      <div class="max-w-6xl mx-auto px-4 sm:px-6">
        <div class="relative px-8 py-12 [border-image:linear-gradient(to_right,transparent,var(--color-slate-800),transparent)1]">
          <x-glow :type="2" />
          <div class="max-w-3xl mx-auto text-center">
            <div>
              <div class="inline-flex font-medium bg-clip-text text-transparent bg-linear-to-r from-purple-500 to-purple-200 pb-3">Error</div>
            </div>
            <h2 id="error-code" class="h2 bg-clip-text text-transparent bg-linear-to-r from-slate-200/60 via-slate-200 to-slate-200/60 pb-4">{{ error.code }}</h2>
            <p class="text-lg text-slate-400 mb-8">
              <span id="error-message">{{ error.message }}</span>
            </p>
            <div>
              <button id="error-reset-button" class="x-button w-1/2" :class="{ 'x-disabled': disabled }" @click="reset">
                <span v-if="loading">Loading...</span>
                <span v-else>Reset</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script lang="ts">
export default {
  setup() {
    //
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      required: true
    },
    modelValue: String
  },
  computed: {
    disabled() {
      return this.loading;
    }
  },
  emits: {
    reset: null
  },
  mounted() {
    //
  },
  data() {
    return {
      //
    };
  },
  methods: {
    reset() {
      this.$emit("reset");
    }
  }
};
</script>
